module.exports = __webpack_public_path__ + "6b608a432526c0ab3f60f8066a0ff4c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/addons/images/homeimage2.jpg
// module id = 1351
// module chunks = 17